import { topics } from "@/mocks/homeData";

export default function TopicTags() {
  return (
    <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-12">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-4">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-hashtag text-base" />
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热门话题索引</h3>
        </div>
        <div className="flex flex-1 flex-wrap gap-2">
          {topics.map((topic, idx) => (
            <a
              key={topic}
              href="#live"
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 font-label text-[13px] transition-colors duration-200 ${
                idx % 3 === 1
                  ? "bg-accent-100 text-accent-900 hover:bg-accent-200"
                  : "bg-background-50 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              #{topic}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}